// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  apiRpps: {
    url: 'https://ws-rpps.vivacy.com/rpps/check',
    username: 'smD5thohv^GAUQ7R&%v@45egr',
    password: 'a#gntKhiV6!5ibBW*$*msfhiu',
  },

  sendinblue: {
    apiKey:
      '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',
    baseUrl: 'https://api.sendinblue.com/v3',
    newsletterId: 78,
  },
/*
  firebase: {
    apiKey: 'AIzaSyC2Qc5Z6aRmIu3IIlrTk7mNyCrlJ2-3IMc',
    authDomain: 'vivacy-backoffice-dev.web.app',
    databaseURL:
      'https://vivacy-dev-67ec1-default-rtdb.europe-west1.firebasedatabase.app',
    projectId: 'vivacy-dev-67ec1',
    storageBucket: 'vivacy-dev-67ec1.appspot.com',
    messagingSenderId: '1016180909710',
    appId: '1:1016180909710:web:84bfe60a78870912940bdf',
  },
*/

  firebase: {
    apiKey: 'AIzaSyAP2A0jD7WtA6BaxDC_9Sg9ZGStr9xsZWc',
    authDomain: 'vivacy-96b29.firebaseapp.com',
    databaseURL:
      'https://vivacy-96b29-default-rtdb.europe-west1.firebasedatabase.app',
    projectId: 'vivacy-96b29',
    storageBucket: 'vivacy-96b29.appspot.com',
    messagingSenderId: '334428967318',
    appId: '1:334428967318:web:e7a8ece7e5f8dcd88d0db7',
    measurementId: 'G-D4CNLC5QFH',
  },

};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
